<template>
  <fieldset class="tla-form-group tla-form-group--margin-medium">
    <label class="tla-form-group__label tla-form-group__label--required" v-html="questionText"></label>

    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in previousManufacturerDetailOptions"
        :key="item.touchpointValue"
        :collectionName="'previousManufacturerDetail'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isRadioStyle="true"
        :isSelected="item.preSelect"
        :validationScope="validationScope"
        @previousManufacturerDetail="submitPreviousManufacturerDetail($event)">
        <touchpointText slot="touchpoint" :content="item.touchpointName"></touchpointText>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('previousManufacturerDetail', 'message')">
      Please select an option.
    </span>
  </fieldset>
</template>

<script lang='ts'>
import {
  Component,
  Prop,
  Vue,
  Watch,
  Inject
} from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import KeyValue from '../../models/KeyValue';
import { tokenService } from '../../services/TokenService';
import Touchpoint from '../../models/Touchpoint';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import GenericTouchPointTextComponent from '../ui/GenericTouchPointTextComponent.vue';
import ExtraData from '../../models/ExtraData';

@Component({
  components: {
  touchpoint: GenericTouchPointComponent,
  touchpointText: GenericTouchPointTextComponent
  }
  })
export default class CurrentRecentManufacturerDetailsComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Is your current/most recent vehicleType a manufacturerName?' })
  public label!: string;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({
    default: () => [
      new KeyValue('Yes', 'Yes'),
      new KeyValue('No', 'No')]
  })
  public options!: KeyValue[];

  private previousManufacturerDetailOptions: Touchpoint[] = [];

  public submitPreviousManufacturerDetail(value: string) {
    const extraData = new ExtraData('isCurrentMostRecentManufacturer', value);
    this.$store.dispatch('enquiryModule/submitExtraData', extraData);
  }

  public get questionText() {
    return tokenService.replaceToken(this.label);
  }

  public get manufacturer() {
    const currentManufacturer = this.$store.getters['vehicleModule/currentManufacturer'];
    if (currentManufacturer !== null) {
      return currentManufacturer;
    }
    return null;
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }

  public mounted() {
    this.previousManufacturerDetailOptions = this.options.map(
      (a: any) => new Touchpoint(a.value, a.key)
    );
  }
}
</script>
